/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WunschspracheInputs */

const en__field_wunschsprache = /** @type {(inputs: _Field_WunschspracheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desired Language`)
};

const de__field_wunschsprache = /** @type {(inputs: _Field_WunschspracheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wunschsprache`)
};

/**
* | output |
* | --- |
* | "Desired Language" |
*
* @param {_Field_WunschspracheInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_wunschsprache = /** @type {((inputs?: _Field_WunschspracheInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WunschspracheInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_wunschsprache(inputs)
	return de__field_wunschsprache(inputs)
});